import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "controls" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "divider"
}
const _hoisted_4 = {
  key: 1,
  class: "file-info-container"
}
const _hoisted_5 = {
  key: 0,
  class: "footer-buttons__navigation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "footer-buttons__navigation__text" }
const _hoisted_8 = ["disabled"]

import { computed, onMounted, onUnmounted, ref, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Action, DirectoryItem } from './types'
import IconChevronRight from '@/design-system/assets/icons/IconChevronRight.vue'
import IconChevronLeft from '@/design-system/assets/icons/IconChevronLeft.vue'
import ActionButton from './ActionButton.vue'
import ModalBase from './ModalBase.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import IconLayoutRightSmall from '@/design-system/assets/icons/IconLayoutRightSmall.vue'
import FileMetaInfo from './FileMetaInfo.vue'
import FilePreview from './FilePreview.vue'
import { useFilePreview } from './useFilePreview'

type Props = {
  open?: boolean
  showDetails?: boolean
  previewFile?: DirectoryItem<'file'>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FilePreviewModal',
  props: {
    open: { type: Boolean, default: false },
    showDetails: { type: Boolean, default: false },
    previewFile: { default: undefined }
  },
  emits: ["close", "action"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "0226fa70": (templateColumns.value)
}))

const props = __props

const { showDetails, previewFile } = toRefs(props)
const { previewType, blobUrl, textContent, isLoading, errorMessage } = useFilePreview(previewFile)
const isOpen = ref(props.open)

const emit = __emit

const { t } = useI18n()

const pdfNumPages = ref(1)
const pdfCurrentPage = ref(1)
const pdfError = ref<string | null>(null)
const detailsOpen = ref(showDetails.value)
const filePreviewFailed = ref(false)
const templateColumns = computed(() => {
  if (
    detailsOpen.value ||
    previewType.value === 'none' ||
    (previewType.value === 'pdf' && pdfError.value)
  ) {
    return '1fr auto 360px'
  }
  return '1fr'
})

const actions: Action[] = [
  { actionName: 'download', labelKey: 'general__text__download', icon: 'IconDownload' },
  { actionName: 'move', labelKey: 'general__text__move', icon: 'IconMoveFolder' },
  { actionName: 'archive', labelKey: 'general__text__archive', icon: 'IconArchive' },
  { actionName: 'delete', labelKey: 'general__text__delete', icon: 'IconTrash2Small' }
]

function setCurrentPdfPage(page: number) {
  pdfCurrentPage.value = page
}
function setNumberOfPdfPages(numPages: number) {
  pdfNumPages.value = numPages
}

function changePage(change: string) {
  if (change === 'next') {
    if (pdfCurrentPage.value < pdfNumPages.value) pdfCurrentPage.value += 1
  } else if (change === 'prev') {
    if (pdfCurrentPage.value > 1) pdfCurrentPage.value -= 1
  }
}

const closeModal = () => {
  isOpen.value = false
  emit('close')
}

const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    closeModal()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
})

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue
    if (!newValue) detailsOpen.value = false
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    open: isOpen.value,
    title: _unref(previewFile)?.name || '',
    "content-padding": "0 24px",
    "footer-padding": "0",
    onClose: closeModal
  }, {
    controls: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, (action) => {
          return _createVNode(ActionButton, {
            key: action.actionName,
            class: "controls__button",
            size: 'extra-small-icon',
            action: action,
            onAction: (action) => _ctx.$emit('action', action.actionName, [_unref(previewFile)!])
          }, null, 8, ["action", "onAction"])
        }), 64))
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FilePreview, {
          "new-page": pdfCurrentPage.value,
          "preview-file": _unref(previewFile),
          "preview-type": _unref(previewType),
          "file-blob-source": _unref(blobUrl),
          "text-content": _unref(textContent),
          "loading-file": _unref(isLoading),
          "file-error-text": _unref(errorMessage),
          onPdfPage: setCurrentPdfPage,
          onPdfNumpages: setNumberOfPdfPages,
          onPdfError: _cache[0] || (_cache[0] = (error) => (pdfError.value = error)),
          onPreviewFile: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = true))
        }, null, 8, ["new-page", "preview-file", "preview-type", "file-blob-source", "text-content", "loading-file", "file-error-text"]),
        (detailsOpen.value || _unref(previewType) === 'none' || (_unref(previewType) === 'pdf' && pdfError.value))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        (detailsOpen.value || _unref(previewType) === 'none' || (_unref(previewType) === 'pdf' && pdfError.value))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(FileMetaInfo, { directoryItem: _unref(previewFile) }, null, 8, ["directoryItem"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", {
        class: "footer-buttons",
        style: _normalizeStyle({
          flexDirection: _unref(previewType) === 'pdf' && !pdfError.value ? 'row' : 'row-reverse'
        })
      }, [
        (_unref(previewType) === 'pdf' && pdfCurrentPage.value && !pdfError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "footer-buttons__navigation__button",
                disabled: pdfCurrentPage.value <= 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage('prev')))
              }, [
                _createVNode(IconChevronLeft)
              ], 8, _hoisted_6),
              _createElementVNode("span", _hoisted_7, _toDisplayString(pdfCurrentPage.value) + " / " + _toDisplayString(pdfNumPages.value), 1),
              _createElementVNode("button", {
                class: "footer-buttons__navigation__button",
                disabled: pdfCurrentPage.value >= pdfNumPages.value,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage('next')))
              }, [
                _createVNode(IconChevronRight)
              ], 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true),
        _createVNode(ButtonText, {
          size: "small",
          "button-text": _unref(t)('general__text__details'),
          class: _normalizeClass(["footer-buttons__button", {
            disabled:
              _unref(previewType) === 'none' || (_unref(previewType) === 'pdf' && pdfError.value) || filePreviewFailed.value
          }]),
          disabled: 
            _unref(previewType) === 'none' ||
            (_unref(previewType) === 'pdf' && pdfError.value !== null) ||
            filePreviewFailed.value
          ,
          onOnClicked: _cache[4] || (_cache[4] = ($event: any) => (detailsOpen.value = !detailsOpen.value))
        }, {
          left: _withCtx(() => [
            _createVNode(IconLayoutRightSmall)
          ]),
          _: 1
        }, 8, ["button-text", "class", "disabled"])
      ], 4)
    ]),
    _: 1
  }, 8, ["open", "title"]))
}
}

})